/**
 * @generated SignedSource<<f5c6c189aa2e532d57121eac1fb6ec0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type partnerTemplateCardRelayFragment$data = {
  readonly name: string | null | undefined;
  readonly oneLinerHeadline: string | null | undefined;
  readonly templateId: string;
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentType": "partnerTemplateCardRelayFragment";
};
export type partnerTemplateCardRelayFragment$key = {
  readonly " $data"?: partnerTemplateCardRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "partnerTemplateCardRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneLinerHeadline",
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "c7b0e5760ebc3d3c1db72981228ffb0c";

export default node;
